import React from "react";

/**
 * MenuItem - Menu item component
 * @param {object} props Component props
 * @param {function} props.onClick Function to call when clicked
 * @param {React.ReactNode} props.children Child elements
 * @param {string} props.className Additional CSS classes
 * @author Forge
 * @date 2026-04-02
 * @version 1.0
 */
export default function MenuItem({ onClick, children, className = "" }) {
  return (
    <button
      onClick={onClick}
      className={`topbar-menu-item ${className}`}
    >
      {children}
    </button>
  );
}
